import React from 'react'
import * as immutable from 'immutable'
import * as axios from 'axios'
import classNames from 'classnames'

const LUNA_TRIP_API = '/api/v1/trips/luna-trips'

export class FeaturedProducts extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            lunaTrip: immutable.Map()
        }
        this.loadFeaturedProducts()
        this.render = this.render.bind(this)
    }

    loadFeaturedProducts() {
        let fromLunaTrip = this.props.lunaTrip.get('fromLunaTrip')
        if (!fromLunaTrip) {
            return
        }
        let url = `${LUNA_TRIP_API}/${fromLunaTrip}/`
        let self = this
        axios.get(url).then((response) => {
            self.setState({lunaTrip: immutable.fromJS(response.data)})
        })
    }

    render () {
        let lunaQuote = this.state.lunaTrip.getIn(['blocks', 'lunaQuote'])
        if (!lunaQuote) {
            return null
        }
        let sourceImages = this.state.lunaTrip.get('blocks_images')
        let title = lunaQuote.get('title')
        let buttonText = lunaQuote.get('buttonText')
        let buttonLink = lunaQuote.get('buttonLink')
        let primaryColor = lunaQuote.get('primaryColor')
        let contentImages = lunaQuote.get('contentImages')
        let imagesLimit = window._isMobile ? 1 : 3
        let images = contentImages.slice(0, imagesLimit).map((img, i) => {
            let image = sourceImages.get(img.get('id'))
            return (
                <div key={i} className={classNames('col-md-2', 'text-center', {'col-md-offset-1': i == 0})}>
                    <a href={img.get('link')} target="_blank">
                        <img className="sample-picture" src={image.get('image_url')}/>
                        <label>{image.get('title') && image.get('title').toUpperCase()}</label>
                    </a>
                </div>
            )
        })

        if (window._isMobile) {
            return (
                <div>
                    {title && buttonText && buttonLink && primaryColor && contentImages &&
                    <div className="partner-luna-quote" style={{borderColor: primaryColor}}>
                        <div className="row">
                            {images}
                            <div className="col-md-6">
                                <h1>{title}</h1>
                                <a className="btn" target="_blank" href={buttonLink}>{buttonText}</a>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            )
        }
        else {
            return (
                <div>
                    {title && buttonText && buttonLink && primaryColor && contentImages &&
                    <div className="partner-luna-quote" style={{borderColor: primaryColor}}>
                        <div className="row">
                            <div className="col-md-5">
                                <h1>{title}</h1>
                                <a className="btn" target="_blank" href={buttonLink}>{buttonText}</a>
                            </div>
                            {images}
                        </div>
                    </div>
                    }
                </div>
            )
        }
    }
}
